// extracted by mini-css-extract-plugin
export default {"UneversalDelete":"UneversalDelete_UneversalDelete__qa0Sc","СonfirmDeleteInner":"UneversalDelete_СonfirmDeleteInner__gSE3z","ButtonInner":"UneversalDelete_ButtonInner__ewINv"};